import i18n from "@/libs/i18n/i18n";

export const initialState = {
    oldReceptionsReferrals: [],
    oldReceptionsConsulates: [],
    receptions: [],
    nowTime: '',
    total: 0,
    receptionTypes: [],
    receptionToManage: '',
    userToManage: '',
    receptionsToCreate: [{
        receptionId: null,
        serviceId: null,
        doctorId: null,
        // discountGroupId :null,
        status: "active"
    }],
    usersList: [],
    discountsList: [],
    receptionServices: [],
    doneReceptions: [],
    noCharge: false,
    repeat: false,
    description:null,
    receptionToPayForServices: null,
    receptionToPayFor: null,
    patientPayment: [{
        receptionId:null,
        getTheAmountAccountingDocumentId:null,
        identificationReceivedPatientAccountingDocumentId: null,
        paymentType:"pos",
        detailAccountId:null,
        terminalId:null,
        amount:0,
        description: null
        }],
    excessPayment: [{
        receptionId:null,
        paymentType:"pos",
        detailAccountId:null,
        amount:0,
        }],
    serviceReturn: {
        receptionId:null,
        amount: '',
        },
    currentExcessPayment: [],
    allPayments: [],
    receptionServicesRows: null,
    //for add visit service
    visitServices:[],
    // createdReceptionIdForAddVisit:null,
    createdVisitService:null,
    createdReception:null,
    usersForVisit: null,
    discountsForVisit: null,
    addedVisitService: [],
    returnTypes:[
        { value: 'hospital', text: i18n.t('reception.returnTypes.hospital') },
        { value: 'doctor', text: i18n.t('reception.returnTypes.doctor') },
        { value: 'doctorAndHospital', text: i18n.t('reception.returnTypes.doctorAndHospital') }
    ],
    currentServiceReturns: [],
    doneReceptionsForThisRoom: [],
    doctors: [],
    insurances: [],
    currentDayReceptions:[],
    currentDayReceptionSearch:{fullName: '', doctorId: '', insuranceId:'', nationalCode:''},
    paymentToEdit: null,
    callingDoctors: [],
}
